import { Action } from '@ngrx/store';
import { Studio } from './studio.model';
import { HttpErrorResponse } from '@angular/common/http';

export const GET = '[Studio] Get';
export const GET_COMPLETE = '[Studio] Get Complete';
export const GET_FAILED = '[Studio] Get Failed';
export const LIST_BY_USER = '[Studio] List By User';
export const LIST_BY_USER_COMPLETE = '[Studio] List By User Complete';
export const LIST_BY_USER_FAILED = '[Studio] List By User Failed';
export const SELECT = '[Studio] Select';
export const SELECT_COMPLETE = '[Studio] Select Complete';
export const UPDATE_STUDIO = '[Studio] Update Studio';
export const UPDATE_STUDIO_COMPLETE = '[Studio] Update Studio Complete';
export const UPDATE_STUDIO_FAILED = '[Studio] Update Studio Failed';

export const EXPORT_CSV_BY_STUDIO_USERS = '[Studio] Export CSV All Studio Users';
export const EXPORT_CSV_BY_STUDIO_USERS_COMPLETE = '[Studio] Export CSV Studio Users Complete';
export const EXPORT_CSV_BY_STUDIO_USERS_FAILED = '[Studio] Export CSV Studio Users Failed';

export const EXPORT_CSV_BY_STUDIO_FEATURE_USERS = '[Studio] Export CSV All Feature Users';
export const EXPORT_CSV_BY_STUDIO_FEATURE_USERS_COMPLETE = '[Studio] Export CSV Feature Users Complete';
export const EXPORT_CSV_BY_STUDIO_FEATURE_USERS_FAILED = '[Studio] Export CSV Feature Users Failed';

export const EXPORT_CSV_BY_STUDIO_DIVISION_USERS = '[Studio] Export CSV All Division Users';
export const EXPORT_CSV_BY_STUDIO_DIVISION_USERS_COMPLETE = '[Studio] Export CSV Division Users Complete';
export const EXPORT_CSV_BY_STUDIO_DIVISION_USERS_FAILED = '[Studio] Export CSV Division Users Failed';

export class GetAction implements Action {
    readonly type = GET;

    constructor(public payload: number) { }
}

export class GetCompleteAction implements Action {
    readonly type = GET_COMPLETE;

    constructor(public payload: Studio) { }
}

export class GetFailedAction implements Action {
    readonly type = GET_FAILED;

    constructor(public payload: { error: any }) { }
}

export class ListByUserAction implements Action {
    readonly type = LIST_BY_USER;

    constructor(public payload: number) { }
}

export class ListByUserCompleteAction implements Action {
    readonly type = LIST_BY_USER_COMPLETE;

    constructor(public payload: Studio[]) { }
}

export class ListByUserFailedAction implements Action {
    readonly type = LIST_BY_USER_FAILED;

    constructor(public payload: { error: any, userId: number }) { }
}

export class SelectAction implements Action {
    readonly type = SELECT;

    constructor(public payload: number) { }
}

export class SelectCompleteAction implements Action {
    readonly type = SELECT_COMPLETE;

    constructor() { }
}

export class UpdateStudioAction implements Action {
    readonly type = UPDATE_STUDIO;

    constructor(public payload: { name: string, studioId: number, isStudioReadOnly: boolean }) { }
}

export class UpadteStudioCompleteAction implements Action {
    readonly type = UPDATE_STUDIO_COMPLETE;

    constructor(public payload: Studio) { }
}

export class UpdateStudioFailedAction implements Action {
    readonly type = UPDATE_STUDIO_FAILED;

    constructor(public payload: { error: any }) { }
}

export class ListByStudioUsersAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_USERS;

    constructor(public payload: { studioId: number }) { }
}

export class ListByStudioUsersCompleteAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_USERS_COMPLETE;

    constructor(public payload: {}) { }
}

export class ListByStudioUsersFailedAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_USERS_FAILED;

    constructor(public payload: { error: HttpErrorResponse }) { }
}

export class ExportCsvStudioFeatureUsersAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_FEATURE_USERS;

    constructor(public payload: { studioId: number }) { }
}

export class ExportCsvStudioFeatureUsersCompleteAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_FEATURE_USERS_COMPLETE;

    constructor(public payload: {}) { }
}

export class ExportCsvStudioFeatureUsersFailedAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_FEATURE_USERS_FAILED;

    constructor(public payload: { error: HttpErrorResponse }) { }
}
export class ExportCsvStudioDivisionUsersAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_DIVISION_USERS;

    constructor(public payload: { studioId: number }) { }
}

export class ExportCsvStudioDivisionUsersCompleteAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_DIVISION_USERS_COMPLETE;

    constructor(public payload: {}) { }
}

export class ExportCsvStudioDivisionUsersFailedAction implements Action {
    readonly type = EXPORT_CSV_BY_STUDIO_DIVISION_USERS_FAILED;

    constructor(public payload: { error: HttpErrorResponse }) { }
}
export type Actions
    = GetAction
    | GetCompleteAction
    | GetFailedAction
    | ListByUserAction
    | ListByUserCompleteAction
    | ListByUserFailedAction
    | SelectAction
    | SelectCompleteAction
    | UpdateStudioAction
    | UpadteStudioCompleteAction
    | UpdateStudioFailedAction
    | ListByStudioUsersAction
    | ListByStudioUsersCompleteAction
    | ListByStudioUsersFailedAction
    | ExportCsvStudioFeatureUsersAction
    | ExportCsvStudioFeatureUsersCompleteAction
    | ExportCsvStudioFeatureUsersFailedAction
    | ExportCsvStudioDivisionUsersAction
    | ExportCsvStudioDivisionUsersCompleteAction
    | ExportCsvStudioDivisionUsersFailedAction;
